import { useFormik } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'
import { AuthenticationGuard, Button, Input } from '../../components'
import { useCogfy, useToasts } from '../../hooks'

export function CreateProfilePage () {
  const [error, setError] = useState<unknown | null>(null)
  const cogfy = useCogfy()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const toasts = useToasts()
  const formik = useFormik({
    initialValues: {
      password: ''
    },
    validationSchema: yup.object().shape({
      password: yup
        .string()
        .min(8, 'Password must have at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/\d/, 'Password must contain at least one number')
        .matches(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/, 'Password must contain at least one symbol')
        .required('Password is required')
    }),
    onSubmit: async values => {
      try {
        await cogfy.setInitialPassword({ password: values.password })

        navigate('/')
      } catch (error) {
        setError(error)
        toasts.error('Error creating profile')
      }
    }
  })

  return (
    <AuthenticationGuard>
      <div className="h-screen w-screen flex flex-col justify-center items-center bg-gray-100">
        <div className="text-center min-w-96 border rounded-lg p-6 shadow-md bg-white">
          <h1 className="text-2xl font-bold text-primary">
            {t('createProfilePage:Create profile')}
          </h1>
          <form
            onSubmit={formik.handleSubmit}
            className="text-center w-full"
          >
            <Input
              label={t('createProfilePage:Set password')}
              type="password"
              placeholder={t('Password')}
              disabled={formik.isSubmitting}
              helperText="Must have at least 8 characters, including uppercase, lowercase, number and symbol"
              error={Boolean(formik.touched.password && formik.errors.password)}
              {...formik.getFieldProps('password')}
            />
            <Button
              disabled={formik.isSubmitting}
              type="submit"
              color="primary"
              className="w-full mt-4"
            >
              {t('Confirm')}
            </Button>
          </form>
          {formik.submitCount > 0 && !formik.isSubmitting && Boolean(error) && (
            <div className="text-center py-4">
              <p className="text-error">
                {t('firstAccessPage:Error setting password')}.
              </p>
            </div>
          )}
        </div>
      </div>
    </AuthenticationGuard>
  )
}
